import {
  LOCKED_LIST_FAILED,
  LOCKED_LIST_LOADDATA,
  LOCKED_LIST_LOADING,
  LOCKED_LIST_SUCCESS,
} from "redux/constants/LockedListConst";

export const success = (data) => {
  return {
    type: LOCKED_LIST_SUCCESS,
    data,
  };
};

export const failed = () => {
  return {
    type: LOCKED_LIST_FAILED,
  };
};

export const loading = () => {
  return {
    type: LOCKED_LIST_LOADING,
  };
};

export const loaddata = ({ page: page, filter: filter }) => {
  return {
    type: LOCKED_LIST_LOADDATA,
    page,
    filter,
  };
};
